import { Button, Col, Modal, Row } from "react-bootstrap";
import styled from "styled-components";
import { colors, types } from "../../../libs";

export const ModalHeader = styled(Modal.Header)`
  background: ${colors.background.lightBlack};
  color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
    color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
  position: sticky;
  top: 0;
  z-index: 10;
`;
export const OrderSelectionWrapper = styled.div`
  display: flex;
  height: calc(100vh - 50px);
  width: 100%;
`
export const LeftSection = styled.div`
 width: 50%;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
  `;
export const RightSection = styled.div`
    width: 50%;
    padding: 30px;
    display: flex;
    justify-content: center;
    background-color:#121419;
    align-items: center;
    gap: 10px; 
  `;
export const PreviewWrapper = styled.div`
  height: 100%;
`;

export const PreviewHeader = styled.h5`
   ${types.body.normal};
   font-weight:600;
   margin-top: 7px;
   color: ${colors.text.gray};
 display: flex;
 justify-content: center;
`;

export const OrderSelectionRow = styled(Row)`
    .MuiTableHead-root {
        .MuiTableCell-root {
            border: none;
        }
    }
    .MuiTableBody-root{
        .MuiTableRow-root{
            &:nth-child(1){
                .MuiTableCell-root {
                    border-top: 1px solid ${colors.background.darkGreen};
                }
                .MuiTableCell-root:nth-child(1) {
                    border-top-left-radius: 0.5rem;
                }
                .MuiTableCell-root:nth-last-child(1) {
                    border-top-right-radius: 0.5rem;
                }
            }
            
            &:last-child {
                .MuiTableCell-root:nth-child(1) {
                    border-bottom-left-radius: 0.5rem;
                }
                .MuiTableCell-root:nth-last-child(1) {
                    border-bottom-right-radius: 0.5rem;
                }
            }
            .MuiTableCell-root {
                border-color: ${colors.background.darkGreen};
                
                &:nth-child(1){
                    border-left: 1px solid ${colors.background.darkGreen};
                }
                &:nth-last-child(1){
                    border-right: 1px solid ${colors.background.darkGreen};
                }
            }
        }
    }
`
export const OrderSelectionCol = styled(Col)``

export const OrderSelectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

export const OrderSelectionHeaderText = styled.h3`
    ${types.headers.itemSmall};
    color: ${colors.text.white};
    margin: 0.5rem 0;
`

export const OrderSelectionHeaderActions = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
`

interface CardProps {
  selected?: boolean;
  changed?: boolean;
}

export const LayoutGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  `;

export const LayoutCard = styled.div<CardProps>`
    border: 2px solid ${({ selected, changed }) => (selected ? (changed ? "#FFA500" : "#B7F84D") : "transparent")};
    border-radius: 10px;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #1f1f1f;
    cursor: pointer;
    transition: border 0.3s ease;
  
    img {
      width: 160px;
      height: 81px;
      object-fit: contain;
    }
  
    &:hover {
      border-color: ${({ selected, changed }) => (selected ? (changed ? "#FFA500" : "#B7F84D") : "#888")};
    }
  `;

export const LayoutCardContainer = styled.div`
  background-color: ${colors.background.darkGray};
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CustomButton = styled(Button)`
  background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  padding: 8px 16px; 
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap; 
  &:hover {
    background: ${colors.background.lightGrey};
  }
`;

export const SaveButton = styled(Button)`
  margin-left: 8px;
`;